import AddIcon from '@mui/icons-material/Add';
import { Button, SxProps } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { theme } from '../../../../styles/theme';
import { EditIcon } from '../../../../assets/icons/edit-icon/edit-icon';
import { buttonColor } from '../../../../styles/color-constants';

interface Props {
  onClick?: () => void;
  id?: string;
  isEdit?: boolean;
}

const styles: { [key: string]: SxProps } = {
  button: {
    marginRight: 'auto',
    textTransform: 'none',
    fontSize: '20px',
    fontWeight: 'normal',
    color: theme.colors.textButton.specialTextColor,
  },
  icon: {
    marginRight: '10px',
  },
  editIcon: {
    width: '24px',
    height: '24px',
    padding: '3px',
    paddingRight: '1px',
  },
};

export const AddNewButton: FC<Props> = React.memo((props) => {
  const { onClick } = props;

  const localOnClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  return (
    <Button sx={styles.button} disableRipple onClick={localOnClick} id={props.id}>
      {props.isEdit ? (
        <EditIcon sx={[styles.editIcon, styles.icon]} color={buttonColor} />
      ) : (
        <AddIcon sx={styles.icon} />
      )}
      {props.children}
    </Button>
  );
});
